// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
    /* max-height: calc(100vh - 365px); */
    overflow: auto;
}

table {
    overflow: auto;
    border-collapse: collapse;
    width: 100%;
}

.table-spec {
    width: 100%;
    max-width: 100%;
    empty-cells: show;
    border: 0;
}

td, th {
    border: 1px solid #dddddd;
    text-align: left;
    font-weight: normal;
}

td {
    padding: 6px 4px;
}

th {
    border-top: none;
    position: sticky;
    top: 0;
    padding: 5px;
    background: #212529;
    color: #ffffff;
    font-size: 14px;
    z-index: 1;
    background-clip: padding-box;
}

tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

td .txtarea {
    width: 100% !important;
}

td textarea:hover {
    border: 1px solid gray !important;
}

.first td:nth-child(1) {
    color: teal;
}

span:hover {
  position: relative;
}

span[aria-label]:hover:after {
  content: attr(aria-label);
  padding: 4px 8px;
  position: absolute;
  left: 130px;
  top: 0;
  white-space: nowrap;
  z-index: 9999;
  background:teal;
  color: white;
  border-radius: 5px;
  font-size: 16px;
}

span[aria-label-action]:hover:after {
    content: attr(aria-label-action);
    padding: 4px 8px;
    position: absolute;
    right: 30px;
    top: -10px;
    white-space: nowrap;
    z-index: 999999;
    background:teal;
    color: white;
    border-radius: 5px;
    font-size: 16px;
  }

  span[aria-label-icon]:hover:after {
    content: attr(aria-label-icon);
    padding: 4px 8px;
    position: absolute;
    right: 50px;
    top: -25px;
    white-space: nowrap;
    z-index: 999999;
    background:teal;
    color: white;
    border-radius: 5px;
    font-size: 12px;
  }

  .sampledDateDataScientist{
      width:7%;
  }
  .analyzingDateDataScientist{
    width:7%;
  }
  .completedDateDataScientist{
    width:7%;
  }
  .unitDistanceDataScientist{
    width:7%;
  }
  .statusDataScientist{
    width:8%;
  }
  .statusExt{
    width:8%;
  }
  .statusLab{
    width:8%;
  }
  .statusCmi{
    width:8%;
  }

  ::ng-deep .mat-slide-toggle-thumb {    
    cursor: pointer;
}

.highlight{
  color: #4a8e1c!important;
 }
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/View/core/analyze-sample/analyze-sample-grid/analyze-sample-grid.component.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;MACI,QAAQ;EACZ;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;AACnB;;AAEA;EACE,wBAAwB;CACzB;AACD,o3JAAo3J","sourcesContent":[".table-container {\r\n    /* max-height: calc(100vh - 365px); */\r\n    overflow: auto;\r\n}\r\n\r\ntable {\r\n    overflow: auto;\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n}\r\n\r\n.table-spec {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    empty-cells: show;\r\n    border: 0;\r\n}\r\n\r\ntd, th {\r\n    border: 1px solid #dddddd;\r\n    text-align: left;\r\n    font-weight: normal;\r\n}\r\n\r\ntd {\r\n    padding: 6px 4px;\r\n}\r\n\r\nth {\r\n    border-top: none;\r\n    position: sticky;\r\n    top: 0;\r\n    padding: 5px;\r\n    background: #212529;\r\n    color: #ffffff;\r\n    font-size: 14px;\r\n    z-index: 1;\r\n    background-clip: padding-box;\r\n}\r\n\r\ntbody tr:nth-child(even) {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\ntd .txtarea {\r\n    width: 100% !important;\r\n}\r\n\r\ntd textarea:hover {\r\n    border: 1px solid gray !important;\r\n}\r\n\r\n.first td:nth-child(1) {\r\n    color: teal;\r\n}\r\n\r\nspan:hover {\r\n  position: relative;\r\n}\r\n\r\nspan[aria-label]:hover:after {\r\n  content: attr(aria-label);\r\n  padding: 4px 8px;\r\n  position: absolute;\r\n  left: 130px;\r\n  top: 0;\r\n  white-space: nowrap;\r\n  z-index: 9999;\r\n  background:teal;\r\n  color: white;\r\n  border-radius: 5px;\r\n  font-size: 16px;\r\n}\r\n\r\nspan[aria-label-action]:hover:after {\r\n    content: attr(aria-label-action);\r\n    padding: 4px 8px;\r\n    position: absolute;\r\n    right: 30px;\r\n    top: -10px;\r\n    white-space: nowrap;\r\n    z-index: 999999;\r\n    background:teal;\r\n    color: white;\r\n    border-radius: 5px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  span[aria-label-icon]:hover:after {\r\n    content: attr(aria-label-icon);\r\n    padding: 4px 8px;\r\n    position: absolute;\r\n    right: 50px;\r\n    top: -25px;\r\n    white-space: nowrap;\r\n    z-index: 999999;\r\n    background:teal;\r\n    color: white;\r\n    border-radius: 5px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .sampledDateDataScientist{\r\n      width:7%;\r\n  }\r\n  .analyzingDateDataScientist{\r\n    width:7%;\r\n  }\r\n  .completedDateDataScientist{\r\n    width:7%;\r\n  }\r\n  .unitDistanceDataScientist{\r\n    width:7%;\r\n  }\r\n  .statusDataScientist{\r\n    width:8%;\r\n  }\r\n  .statusExt{\r\n    width:8%;\r\n  }\r\n  .statusLab{\r\n    width:8%;\r\n  }\r\n  .statusCmi{\r\n    width:8%;\r\n  }\r\n\r\n  ::ng-deep .mat-slide-toggle-thumb {    \r\n    cursor: pointer;\r\n}\r\n\r\n.highlight{\r\n  color: #4a8e1c!important;\r\n }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
